import { createContext, memo, ReactNode, useMemo } from 'react';
import { BehaviorSubject } from 'rxjs';
import useBehaviorSubject from '../../functions/hooks/useBehaviorSubject';
import { useCreation } from '../../functions/hooks/useCreation';
import { SellerOnboardingContext } from './Context';
import { getDefaultCheckListConfig } from './functions/useDefaultCheckListConfig';
import { SellerOnboardingContextProps, StepState } from './types';

const kDefaultContextProps: SellerOnboardingContextProps = {
  enabled: false,
  steps$: new BehaviorSubject<StepState[]>([]),
  config: undefined,
  synthesizedCheckListConfig: getDefaultCheckListConfig({
    isCreator: false,
    isPslPayEnabled: false,
    isPslPayEnforced: false,
    overriddenRequired: false,
  }),
  forceCompletionBeforeProceeding: false,
  sellerOnboardingCompleted: true,
  shouldPresent: false,
};

export const SellerOnboardingPropsContext = createContext<{
  props$: BehaviorSubject<SellerOnboardingContextProps>;
}>(null as any);

export const SellerOnboardingContextProvider = memo(
  ({ children }: { children?: ReactNode }) => {
    const props$ = useCreation(
      () =>
        new BehaviorSubject<SellerOnboardingContextProps>(kDefaultContextProps),
      [],
    );
    const [props] = useBehaviorSubject(props$);
    const value = useMemo(() => ({ props$ }), [props$]);
    return (
      <SellerOnboardingPropsContext.Provider value={value}>
        <SellerOnboardingContext.Provider value={props}>
          {children}
        </SellerOnboardingContext.Provider>
      </SellerOnboardingPropsContext.Provider>
    );
  },
);
